import { HelmetProvider } from "react-helmet-async";
import "./App.module.scss";
// import styles from "./App.module.scss";
import RoutesComponent from "./routes/RoutesComponent";
import ScrollToTop from "./scroll/ScrollToTop";
import "./styles/reset.scss";

function App() {
    return (
        <>
            <HelmetProvider>
                <ScrollToTop />
                <RoutesComponent />
            </HelmetProvider>
        </>
    );
}

export default App;
